import { render, staticRenderFns } from "./TagFilter1.vue?vue&type=template&id=04d0f559&scoped=true"
import script from "./TagFilter1.vue?vue&type=script&lang=js"
export * from "./TagFilter1.vue?vue&type=script&lang=js"
import style0 from "./TagFilter1.vue?vue&type=style&index=0&id=04d0f559&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d0f559",
  null
  
)

export default component.exports